import { PlaybookSection, PlaybookSectionType, PlaybookSubheader } from './types';

export const isSubheaderSection = (section: PlaybookSection): section is PlaybookSubheader => section.type === PlaybookSectionType.SUBHEADER;
